import React from 'react';
import { Stack } from '@mui/material';
import Button from 'components/Common/Button';

interface CustomPaginationPropTypes {
    offset: number;
    pageSize: number;
    total: number;
    onPreviousPress: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onNextPress: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface PaginationButtonPropTypes {
    buttonText: string;
    disabled?: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const PaginationButton = ({ buttonText, onClick, disabled }: PaginationButtonPropTypes) => (
    <Button width={100} title={buttonText} onClick={onClick} disabled={disabled} />
);

const CustomPagination = (props: CustomPaginationPropTypes) => {
    const { onPreviousPress, onNextPress, offset, total, pageSize } = props;
    return (
        <Stack direction="row" justifyContent="flex-end" spacing={3} mt={2}>
            <PaginationButton buttonText="Previous" onClick={onPreviousPress} disabled={offset === 0} />
            {/* offset 0 means its the first page so we shouldn't allow user to press on previous */}
            {/* fix the deducted number when backend is fixed */}
            <PaginationButton buttonText="Next" onClick={onNextPress} disabled={total < pageSize} />
        </Stack>
    );
};

export default CustomPagination;
